export const OVERVIEW_MODAL_PLAYLIST_PARAM = 'playlistId';
export const EnabledOverviewNavigationSources = ['playlist', 'breeze-banner'];